/**
 * fileDownloader.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

import { ErrorSnackBar } from "../components/errorSnackBar.component";

import { authServiceFactory } from "../services/auth.service";
import { groupServiceFactory } from "../services/group.service";

interface FileDownloaderProps {
  groupID: string,
  fileID: string,
  keyID: string,
  didTrigger(): void,
  onError(): void
}

export function FileDownloader(props: FileDownloaderProps): React.ReactElement<any, any> {
  const aRef = React.useRef<HTMLAnchorElement>(null);
  const [src, setSrc] = React.useState<string>("");
  const [errMsg, setErrMsg] = React.useState("");

  React.useEffect(function () {
     const authService = authServiceFactory();
    if (!props.keyID || !props.fileID || !authService.currentAccountMembership) { return; }

    groupServiceFactory().makeFileLink(authService.currentAccountMembership.accountID,
      props.groupID, props.fileID, props.keyID,
      authService.accessToken)
    .then(setSrc)
    .then(null, err => {
      setErrMsg((err as Error).message);
      props.onError();
    });
  }, [props.keyID, props.fileID]);

  React.useEffect(() => {
    if (!src) { return; }
    if (aRef && aRef.current) {
      aRef.current.click();
    }
    setTimeout(() => { setSrc(""); props.didTrigger(); }, 20);
  }, [src]);

  return <>
      <a ref={aRef} download href={src} target="_blank"></a>
      <ErrorSnackBar errMsg={errMsg} didClose={() => setErrMsg("") } />
    </>;
}
